import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Subscription, Subject } from "rxjs";
import { debounceTime, tap } from "rxjs/operators";

@Component({
  selector: "snt-text-box",
  templateUrl: "textbox.component.html",
  standalone: false
})
export class TextBoxComponent {
  @Input() placeholder: string | undefined;
  @Input()
  debounceTime: number = 250;

  @Output()
  value: EventEmitter<string> = new EventEmitter();

  @Output()
  startTyping: EventEmitter<void> = new EventEmitter();
  @Output()
  endTyping: EventEmitter<void> = new EventEmitter();

  private subscription: Subscription | null = null;
  private subject: Subject<string> = new Subject();

  ngOnInit(): void {
    this.subject = new Subject();
    this.subscription = this.subject
      .pipe(
        debounceTime(this.debounceTime),
        tap(() => this.endTyping.emit())
      )
      .subscribe((query) => this.value.emit(query));
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  onInput(value: string): void {
    this.startTyping.emit();
    this.subject.next(value);
  }
}
